import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationLoadDocumentService,
  AdminLoadModel,
  LoadDocumentType
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationLoadDocumentApiService {
  constructor(private apiService: AdministrationLoadDocumentService) {}

  public deleteDocument(loadId: string, documentId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadDocumentDelete(loadId, documentId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editDocument(loadId: string, documentId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadDocumentEdit(loadId, documentId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public shareDocumentWithDriver(loadId: string, documentId: string, sharedWithDriver: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadDocumentSharedWithDriver(loadId, documentId, sharedWithDriver, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addLoadExtraDocument(loadId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadExtraDocumentAdd(loadId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addLoadStopDocument(loadId: string, stopId: string, documentType: LoadDocumentType, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminLoadModel> {
    return this.apiService.adminLoadStopDocumentAdd(loadId, stopId, documentType, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
